<template>
  <div class="wrapper">
    <!-- Carousel Start -->
    <el-carousel trigger="click" :interval="5000" style="height:100vh">
      <el-carousel-item
        v-for="item in carousel"
        :key="item.image"
        style="height:100vh;"
      >
        <div class="md-layout md-align-center-center" style="height:100%">
          <div
            class="md-layout-item md-size-50 md-small-size-100"
            style="background-color:purple; height:100%"
          >
            <div class="text-white pr-carousel-margin-left" style="margin-top: 40%;">
              <h2>{{ item.caption }}</h2>
              <h1 style="font-size:72px; font-weight:bold">{{ item.title }}</h1>
            </div>
          </div>
          <div
            class="md-layout-item md-size-50 md-small-hide"
            style="padding:0;"
          >
            <img
              :src="item.image"
              :alt="image.title"
              style="  object-fit: cover;"
            />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- Carousel end -->
    <div class="main">
      <div class="section">
        <div class="container">
          <!-- Description start -->
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-medium-size-100 mx-auto text-center"
            >
              <h2 class="title text-heading-pr">{{ description.title }}</h2>
              <h4 class="description">{{ description.description }}</h4>
            </div>
          </div>
          <!-- Description end -->
        </div>
        <!-- Services navigation start -->
        <div class="md-layout section">
          <div
            class="md-layout-item md-size-100 md-small-size-100"
            style="padding-right:0; padding-left: 0;"
          >
            <tabs
              :tab-active="1"
              :tab-name="serviceList"
              :tab-icon="['dashboard', 'schedule', 'list']"
              plain
              nav-pills
              color-button="rose"
              pillsAlign="center"
            >
              <!-- here you can add your content for tab-content -->

              <!-- Slot 1 starts -->
              <div
                class="md-layout md-alignment-center-center"
                style="color:white; background-color: #1c1c1c; height: 80vh;"
                slot="tab-pane-1"
              >
                <div
                  class="md-layout-item md-size-30 md-small-size-100 services-margin"
                >
                  <h6>Digital pr</h6>
                  <h3>Every business needs a strategy to 
                           Improve their brand's online presence and 
                          Visibility and we are here to sort it out for
                          You...!</h3>
                  <p>
                   Digital PR is a powerful strategy that helps you strengthen your brand's online presence with the help of Backlinking , Metric Studies , influencer outreach and social media.
We help you to reach your target audience that cannot be reached by traditional offline methods.
                  </p>
                </div>

                <div
                  class="md-layout-item md-size-20 md-small-size-50"
                  style="margin-right: 2%;"
                >
                  <img :src="require('@/assets/img/PR/digital pr.jpeg')" />
                </div>

                <div
                  class="md-layout-item md-size-20 md-small-hide text-primary"
                  style="background-color: white; height:100%;"
                >
                  <div
                    class="md-layout md-alignment-center-center"
                    style="height:100%"
                  >
                    <div class="md-layout-item" style="color: #1c1c1c;">
                      <h3 class="title">
                        We always stay with our clients and respect their
                        business.
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Slot 1 ends -->

              <!-- Slot 2 starts -->

              <div
                class="md-layout md-alignment-center-center"
                style="color:white; background-color: #1c1c1c; height: 80vh;"
                slot="tab-pane-2"
              >
                <div
                  class="md-layout-item md-size-30 md-small-size-100 services-margin"
                >
                  <h6>Content marketing and SEO</h6>
                  <h3>Content is your key to engagement.There's no Business without content.</h3>
                  <p>
                    Content is regarded as a powerful business tool it has the ability to engage users and help in their conversion to customers . We help in creating compelling online content tailored specific to your business. Equipped with the power of our words/syllables/content you will achieve the much needed edge over your competitors.
                  </p>
                </div>

                <div
                  class="md-layout-item md-size-20 md-small-size-50"
                  style="margin-right: 2%;"
                >
                  <img :src="require('@/assets/img/PR/seo.jpg')" />
                </div>

                <div
                  class="md-layout-item md-size-20 text-primary md-small-hide"
                  style="background-color: white; height:100%;"
                >
                  <div
                    class="md-layout md-alignment-center-center"
                    style="height:100%"
                  >
                    <div class="md-layout-item" style="color: #1c1c1c;">
                      <h3 class="title">
                        We always stay with our clients and respect their
                        business.
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Slot 2 ends -->

              <!-- Slot 3 starts -->
              <div
                class="md-layout md-alignment-center-center"
                style="color:white; background-color: #1c1c1c; height: 80vh;"
                slot="tab-pane-3"
              >
                <div
                  class="md-layout-item md-size-30  md-small-size-100 services-margin"
                >
                  <h6>Social Media Marketing</h6>
                  <h3> In a world of likes and comments, it is a necessity for every company to have a dedicated Social Media presence.</h3>
                  <p>
                   The major social media platforms like Facebook , Twitter , LinkedIn and Instagram can dynamically increase exposure
and interest in your company. Social Media Marketing not only helps you to reach the target audience but also helps you to boost conversions and increase your brand awareness.
                  </p>
                </div>

                <div
                  class="md-layout-item md-size-20 md-small-size-50"
                  style="margin-right: 2%;"
                >
                  <img
                    :src="require('@/assets/img/PR/socialmediamarketing.jpg')"
                  />
                </div>

                <div
                  class="md-layout-item md-size-20 text-primary md-small-hide"
                  style="background-color: white; height:100%;"
                >
                  <div
                    class="md-layout md-alignment-center-center"
                    style="height:100%"
                  >
                    <div class="md-layout-item" style="color: #1c1c1c;">
                      <h3 class="title">
                        We always stay with our clients and respect their
                        business.
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Slot 3 ends -->

              <!-- Slot 4 starts -->
              <div
                class="md-layout md-alignment-center-center"
                style="color:white; background-color: #1c1c1c; height: 80vh;"
                slot="tab-pane-4"
              >
                <div
                  class="md-layout-item md-size-30 md-small-size-100 services-margin"
                >
                  <h6>Web design and Development </h6>
                  <h3>Good websites get traffic, Great websites get Businesses</h3>
                  <p>
                    We provide modern web design services that can help your business grow. We design more than just attractive websites, our web design approach focuses on user experience, SEO , ease of use and technical design. With our web designs we ensure your brand and your business reach its highest potential.

                  </p>
                </div>

                <div
                  class="md-layout-item md-size-20 md-small-size-50"
                  style="margin-right: 2%;"
                >
                  <img :src="require('@/assets/img/PR/web development.jpg')" />
                </div>

                <div
                  class="md-layout-item md-size-20 text-primary md-small-hide"
                  style="background-color: white; height:100%;"
                >
                  <div
                    class="md-layout md-alignment-center-center"
                    style="height:100%"
                  >
                    <div class="md-layout-item" style="color: #1c1c1c;">
                      <h3 class="title">
                        We always stay with our clients and respect their
                        business.
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Slot 4 ends -->
            </tabs>
          </div>
        </div>

        <!-- features navigation end -->

        <!-- What makes us different start -->
        <h2 class="title text-center">What makes us different</h2>
        <div class="md-layout text-center md-alignment-center-center section">
          <div
            class="md-layout-item md-size-20 md-small-size-100"
            v-for="(feature, index) in whatMakesUsDifferent"
            :key="index"
          >
            <md-icon class="md-size-3x text-heading-pr"
              >{{feature.icon}}</md-icon
            >
            <h4 class="title" >{{ feature.title }}</h4>
            <p class="text-pr">{{ feature.description }}</p>
          </div>
        </div>
        <!-- What makes us different end -->

        <!-- Testimonials Begin -->

        <!-- https://element.eleme.io/?ref=madewithvuejs.com#/en-US/component/carousel -->

        <div
          class="section section-testimonials-2 section-dark"
        >
          <div class="container">
            <h2 class="title text-center">Testimonials</h2>
            <div class="md-layout">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <el-carousel
                  indicator-position="outside"
                  arrow="never"
                  trigger="click"
                  :interval="5000"
                >
                  <el-carousel-item v-for="testimonial in testimonials" :key="testimonial.name">
                    <testimonial-card card-plain>
                      <div slot="cardAvatarTop" class="md-card-avatar mt-0">
                        <a href="javascript:void(0)">
                          <img class="img" :src="testimonial.image" />
                        </a>
                      </div>
                      <template slot="cardContent">
                        <h5 class="card-description">
                          {{testimonial.content}}
                        </h5>
                        <h4 class="card-title">{{testimonial.name}}</h4>
                      </template>
                    </testimonial-card>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
        <!--Testimonials End -->

         <!-- Clients start -->

         <div >
           <h2 class="title text-center">Our clients</h2>
           <br/>
 <!-- <agile :options="clients.options" style="style=transform: translate(0px); max-height: 20vh;"> -->

          <div
            class="md-layout md-alignment-center-center"
            style="max-height: 20vh;"
          >
            <div
              v-for="logo in clients.logos"
              :key="logo"
              class="md-layout-item md-size-15 md-small-size-50"
              style="max-height: 20vh; min-height: 15vh;"
            >
              <img style="max-height:10vh; max-width:auto; object-fit: contain" :src="require('@/assets/img/PR/logos/' + logo)" />
            </div>
          </div>
        <!-- </agile> -->
         </div>

       

        <!-- Clients End -->

        <!-- About Us Start -->
        <div class="section section-dark">
          <h2 class="title text-center">About Us</h2>
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-size-50 md-small-size-100 text-center text-white">
              {{ aboutUs }}
            </div>
          </div>
        </div>
        <!-- About Us End -->

        <!-- Team Start -->
        <div class="" :style="sectionTeam()">
          <div class="container">
            <div class="md-layout">
              <div
                class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
              >
                <h2 class="title">The Team</h2>
                <br/>
              </div>
            </div>
            <div class="md-layout">
              <div v-for="(person,index) in team" :key="index" class="md-layout-item md-size-33 md-small-size-100">
                <profile-card
                  card-avatar
                  :shadow-normal="false"
                  :no-colored-shadow="false"
                  :card-image="person.image"
                >
                  <template slot="cardContent">
                    <h4 class="card-title">{{person.name}}</h4>
                  </template>
                </profile-card>
              </div>
            </div>  
          </div>
        </div>
        <!-- Team end -->

        <!-- Blog cards start -->
        <div
          class="section-dark"
          style="padding-top: 3em; padding-bottom: 3em; margin-top: 0;"
        >
          <h2 class="title text-center">Latest Blogs</h2>
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-size-20 md-small-size-75" v-for="blog in blogs" :key="blog.id">
              <md-card >
                <div class="md-layout md-align-center-center" v-on:click="openBlog(blog.id, blog.title)">
                  <div class="md-layout-item md-size-100" style="padding: 0;">
                    <img :src="blog.cover" style=" object-fit: cover;" />
                  </div>
                  <md-card-content class="md-layout-item md-size-100">
                    <h4 class="title text-comp-pr" style="color: black !important;">
                      {{blog.title}}
                    </h4>
                    <p class="description text-heading-pr">{{blog.created.d}}-{{blog.created.m}}-{{blog.created.y}}</p>
                    <hr />     
                  </md-card-content>
                </div>
              </md-card>            
            </div>
          </div>
        </div>
        <!-- Blog cards end -->

        <!-- FAQ Start -->
        <div class="section">
          <h2 class="title text-center">Frequently Asked Questions</h2>
          <div class="md-layout md-alignment-center">
            <div class="md-layout-item md-size-66 md-small-size-100">
              <collapse
                :active-tab="1"
                :collapse="[
                  'Why is Digital Marketing so important',
                  'What does Digital Marketing include?',
                  'Why should I hire a Digital Marketing agency instead of doing it In-house?',
                  'Do my online reviews really matter?'
                ]"
                icon="keyboard_arrow_down"
                color-collapse="rose"
              >
                <template slot="md-collapse-pane-1">
                  <p>A per current 2020 trends, there are approximately 700 million Internet users all over India. The projected growth rate for this figure is expected to rise up to 974 million users by the year 2025. This itself a major sign of peak market potential existing for Internet Services in this South Asian country. 2019 witnessed India standing at the 2nd position for the Largest Online Market worldwide, second only to China. The estimated number of Internet users was expected to grow exponentially in both, urban as well as rural regions, thereby signaling a dynamic potential for Internet Access. </p><p><strong><u>- Mobile Connectivity is on the rise! </u></strong></p><p>A major amount of citizens of our country access the Internet using their Mobile Phones. The number of smartphone users was strikingly similar to that of Internet users across India. Contributing factors to the utilization of mobile-heavy Internet access in the country include cheap availability of Mobile Data, an ever-increasing smartphone user base, and rising utility value of smartphones in comparison to desktops and tablets. </p><p><strong><u>- There’s plenty of room for Growth! </u></strong></p><p>Even though our country possesses a large amount of Internet users, the Web Penetration levels took a significantly longer duration to catch up with that rate. There exists a stark difference in the number of women accessing the web in India, which is lower, as compared to men. This bias is extremely evident in rural areas. When taking phenomena like Internet literacy levels and Technological know-how, the user-base has a lower number of Elderly citizens, too. However, upon encouraging Internet accessibility amongst marginalized groups like the female population, geriatric crowds, and rural inhabitants fo the country, India’s digital footprint shall have a momentous growth capacity!</p>
                </template>
                <template slot="md-collapse-pane-2">
                  <p>Generally, Digital Marketing Services include the following key areas: </p><ul><li><p>Social Media Marketing (SMM)</p></li><li><p>Search Engine Optimization (SEO)</p></li><li><p>Content Marketing</p></li><li><p>Search Engine Marketing (SEM)</p></li><li><p>Email Marketing</p></li><li><p>Affiliate/Influencer Marketing</p></li><li><p>Inbound Marketing</p></li><li><p>Viral Marketing</p></li></ul>
                </template>
                <template slot="md-collapse-pane-3">
                  <p>
                    Attempting your hand at Digital Marketing is definitely not frowned upon, however, as
time progresses you’ll realize the importance of hiring a team of experts from the field
and the inestimable difference they can make! When an individual’s full-time job is
tracking one’s digital marketing metrics, modifying algorithms for better growth rates
via PPC marketing, raising a website’s search engine rankings, and providing accurate
social media exposure to brands, hiring him/her shall definitely give your organization
an edge over rival companies.
                  </p>
                </template>
                <template slot="md-collapse-pane-4">
                  <p>
                    Yes, they most definitely do! Time and again we’ve witnessed Businesses ignoring this
key factor during their nurturing process. Looking for a way to rise above the rest in
SERPs (Search Engine Results Pages)? Well, don’t be surprised but Search Engines are
considering your Online Reviews for that! Google caters to delivering the best results to
its users, and what better way than accessing a brand’s Online Reviews? It’s foolish to
ignore a single bad review, thinking it amounts to nothing because, in reality, about 95%
of web users believe that reading one bad review made them deter from said business’
page. Always focus on cultivating good online reviews, ensure you’re showing up on
appropriate review sites, and never forget to respond to bad reviews! Ignoring this
aspect of your Digital Marketing journey may lead to terrible outcomes in the long run.
                  </p>
                </template>
              </collapse>
            </div>
          </div>
        </div>
        <!-- FAQ end -->
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { Tabs, Collapse, TestimonialCard } from "@/components";
import { VueAgile } from "vue-agile";
import { ProfileCard } from "@/components";
import firebase from "firebase";


export default {
  components: {
    Tabs,
    Collapse,
    TestimonialCard,
    ProfileCard
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  data() {
    return {
      image: require("@/assets/img/landing-illustration.jpg"),

      carousel: [
        {
          image: require("@/assets/img/give your brand the spotlight it deserves.jpeg"),
          title: "The spotlight it deserves",
          caption: "Give your company"
        },
        {
          image: require("@/assets/img/a friend in need for all your digital marketing needs.jpg"),
          title: "Digital marketing needs",
          caption: `The “friend in need” for all your`
        },
        {
          image: require("@/assets/img/reach out to right audience at right time.jpg"),
          title: "At the right place",
          caption: "Reach out to the right audience"
        }
      ],
      description: {
        title: "Committed to providing our best service since day one",
        description: `Spotlight Scouts helps bridge the gap between brands and customers.
Our Data-driven approach can help your company make an impact in the Digital World.
Our expertise includes- 

Fixed services area- Driving client-centric results. You wouldn’t have to think twice with Spotlight Scouts.`
      },
      // clients: {
      //   logos: [
      //     "akshaya.png",
      //     "bcg workshop.jpg",
      //     "Blossom Stayz Logo.webp",
      //     "campus events.png",
      //     "cityfurnish.png",
      //     "decathlon.jpg",
      //     "CAAD.png",
      //     "dears in beers.png",
      //     "high flyer gym.jpg",
      //     "jindal steel.png",
      //     "Ladli foundation.png",
      //     "OasisLogo.png",
      //     "pubg2.0.png"
      //   ],
      //   options: {
      //     autoplay: true,
      //     infinite: false,
      //     initialSlide: 10,
      //     autoplaySpeed: 10000,
      //     centerMode: true,
      //     dots: false,
      //     navButtons: false,
      //     slidesToShow: 3,
      //     responsive: [
      //       {
      //         breakpoint: 600,
      //         settings: {
      //           slidesToShow: 1
      //         }
      //       }
      //     ]
      //   }
      // },
      clients: {
        logos: [
          "OasisLogo.png",
          "hokosoko.jpg"
        ],
        options: {
          autoplay: true,
          infinite: false,
          initialSlide: 0,
          autoplaySpeed: 10000,
          centerMode: true ,
          dots: false,
          navButtons: false,
          slidesToShow: 2,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        }
      },
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
        cardProfile2: require("@/assets/img/faces/card-profile6-square.jpg"),
        cardProfile3: require("@/assets/img/faces/card-profile4-square.jpg"),
        cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg")
      },
      serviceList: [
        "Digital PR",
        "Content and SEO",
        "Social Media Marketing",
        "Web Development"
      ],
      features: [
        {
          title: "PR",
          description:
            "We are a nursery school of brands,we help them to create their identity and give them a platform to outshine and influence."
        },
        {
          title: "Wall Art Solutions",
          description:
            "People believe walls have ears. We believe in giving them a voice too, by giving them the textures and gestures to express."
        },
        {
          title: "Interior design",
          description:
            "Home is where the heart is, and the heart cannot be lured with cream painted walls. They need our animations of beauty with the mixture of traditional and modern approach."
        },
        {
          title: "Epoxy furniture",
          description:
            "Two wood screens joined together is not furniture, the thing which gives you comfort and relaxes you cannot be a non living. It has to be an emotion, and we ensure to provide you with beautiful pieces of art, not just furniture."
        },
        {
          title: "Workshops",
          description:
            "We believe that knowledge rots if preserved, and following the same ideology we organise regular workshops to motivate people to create magic with paints."
        }
      ],
      whatMakesUsDifferent: [
        {
          title: "EVERY STRATEGY WE BUILD FOR YOU IS UNIQUE",
          description:
            "Every business is different, we build campaigns and strategies that are customised according to the needs of your business.",
            icon: "check"
        },
        {
          title: "WE APPROACH DIGITAL MARKETING CREATIVELY AND LOGICALLY",
          description:
            "Our team of young developers and creators will help you to set realistic goals which can be achieved by digital marketing. Digital marketing is also an Art and we are its skillful artists.",
            icon: "psychology"
        },
        {
          title: "WE ARE A ONE-STOP SOLUTION FOR ALL YOUR MARKETING NEEDS",
          description:
            "At spotlight scouts we offer you a wide range of services. We help you with Digital PR , Social Media Marketing, Content Marketing, SEO, Web Design and Development.",
            icon: "local_convenience_store"
        },
        {
          title:
            "WE PROVIDE A DEDICATED WORKFORCE FOR EACH AND EVERY CLIENT,FOR EVERY BUSINESS SIZE",
          description:
            "We provide a dedicated workforce for each and every client, we also offer packages and services for businesses of every size.",
            icon: "business"
        }
      ],
      ourProcess: [
        {
          title: "Discussion of the Idea",
          description:
            "Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been standard dummy."
        },
        {
          title: "Handcrafted Templates",
          description:
            "Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been standard dummy."
        },
        {
          title: "Testing for Perfection",
          description:
            "Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been standard dummy."
        },
        {
          title: "Discussion of the Idea",
          description:
            "Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been standard dummy."
        }
      ],
      testimonials: [
        {
          content: "Spotlight scouts team has done an amazing job in helping Oasis Hostel grow digitally. They were able to understand our needs and executed campaigns for the same. Their strategies and plans were effective. We appreciate their dedicated commitment to provide the effective digital solutions.",
          image: require("@/assets/img/PR/testimonials/OasisLogo.png"),
          name: "Oasis Hostels"
        }
      ],
      aboutUs: ` Worried you are not promoting your brand the right way? Let us handle it.  In this Digitally developing world, The old textbook methods can only get you so far whereas Digital Marketing is now a very effecting way to promote your brand. We here at Spotlight Scouts aim to help you provide all the digital marketing and PR assistance your company needs. Specialising in Search Engine Optimization, Web Designing, Social Media Marketing, Back linking and many more skills, you can count on us and our services.  `,
      portfolio: [
        {
          image: require("@/assets/img/nature-2.jpg"),
          title: "Pub Ji Cafe",
          text: "Walls may have ears but they can also have Pub Jis"
        },
        {
          image: require("@/assets/img/nature-3.jpg"),
          title: "Pub Ji Cafe",
          text: "Walls may have ears but they can also have Pub Jis"
        },
        {
          image: require("@/assets/img/nature.jpg"),
          title: "Pub Ji Cafe",
          text: "Walls may have ears but they can also have Pub Jis"
        }
      ],
      team: [
        {
          name: "Sanchit Mahajan",
          image: require("@/assets/img/PR/team/sanchit.png")
        },
        {
          name: "Pratishtha Budhiraja",
          image: require("@/assets/img/PR/team/pratishtha.png")
        },
        {
          name: "Pawan Jangid",
          image: require("@/assets/img/PR/team/pawan.png")
        },
      ],
      blogs: []
    };
  },
  methods: {
    sectionTeam(image) {
      return {
        backgroundImage: `url(${image})`
      };
    },
    openBlog(id, title) {
      title=title.replace(new RegExp(" ", "g"), "-")
      this.$router.push({ path: `/blog/${id}/${title}`})
    }
  },
  created() {
    // this.services.forEach(service => {
    //   this.serviceList.push(service.title);
    //   this.serviceDescList.push(service.description);
    // });

    const vm = this;
    firebase.firestore().collection("blog").where("type", "==", "PR").orderBy("created", "desc").limit(5).get().then(blogs => {
      blogs.forEach(blog => {
        const blogData = blog.data()
        const date = blogData.created.toDate()
        vm.blogs.push({
          title: blogData.title,
          author: blogData.author,
          cover: blogData.cover,
          created: {
            d: date.getDate(),
            m: date.getMonth(),
            y: date.getFullYear()
          },
          id: blog.id
        })
      })
      vm.loaded = true;
    })
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
